export const container = {
  height: '100vh',
  margin: 'auto',
  pointerEvents: 'none',
  position: 'fixed',
  width: '100vw',
  zIndex: 999,
}
